export default {
  getFeedEmOrder: (state) => state.feedEmOrder,
};
